import { apiGet, apiPost, apiPut } from "app/services/apiServices";
import { AgTableClient } from "app/shared/AgTable";
import { useEffect, useRef, useState } from "react";

import Loader from "app/shared/Loader";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import CircleIcon from "@mui/icons-material/Circle";
import {
  Avatar,
  Button,
  Empty,
  Modal,
  Popconfirm,
  Spin,
  Tabs,
  Tag,
  message,
} from "antd";
import SearchInput from "app/shared/SearchInput";
import Typography from "app/shared/Typography";
import "../../Settings.scss";
import PageHeader from "app/shared/PageHeader";
import { useRecoilState } from "recoil";
import { userInfo } from "app/config/States/users";
import TableViewSelector from "app/shared/TableViewSelector";
import {
  API_ENDPOINT_SETTING_REMOVE_WORKSPACE_FROM_GROUP,
  API_ENDPOINT_SETTING_WORKSPACE_LIST,
  API_ENDPOINT_UPDATE_WORKSPACE_META_EMAIL,
} from "../../settings.constants";
import { colorPicker } from "app/utils/color.helper";
import CreateWorkspace from "../CreateWorkspace";
import color from "theme/color";
import { useNavigate } from "react-router-dom";
import UpdateWorkspace from "../UpdateWorkspace";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import moment from "moment";
export default function WorkspaceSetting(props: any) {
  const [tableData, setTableData] = useState([]);
  const [columnDefs, setColumnDefs] = useState<any[]>([]);
  const [isLoading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showModalFor, setShowModalFor] = useState("");
  const [selectedWorkspace, setSelectedWorkspace] = useState<any>(null);
  const [messageApi, contextHolder] = message.useMessage();
  const [userDetails, setUserDetails] = useRecoilState<any>(userInfo);
  const navigate = useNavigate();
  const gridRef = useRef<any>(null);
  const handleSelectWorkspace = (workspaceInfo: any) => {
    localStorage.setItem("currentWorkspace", workspaceInfo?.id);
    setUserDetails({ ...userDetails, currentWorkspace: workspaceInfo });

    navigate("/bookings");
  };
  const handleMoveToEditPage = async (workspaceInfo: any) => {
    let newWorksapceData = { ...userDetails, currentWorkspace: workspaceInfo };
    setUserDetails(JSON.parse(JSON.stringify(newWorksapceData)));
    localStorage.setItem("currentWorkspace", workspaceInfo.id);
    navigate("/settings/workspace/meta");
  };

  const handleRemoveWorksapceFromGroup = async (worksapceId: any) => {
    const response = await apiPost(
      API_ENDPOINT_SETTING_REMOVE_WORKSPACE_FROM_GROUP + worksapceId
    );
    if (response.status) {
      message.success("Workpace removed");
      fetchWorkspaceList();
    } else {
      message.error("Could not workpace removed from intermediary");
    }
  };
  const [workspaceList, setWorkspaceList] = useState<any[]>([]);//new----

  const initialColDefs = [
    {
      field: "name",
      headerName: "Workspace",
      enableRowGroup: true,
      minWidth: 200,
      cellRenderer: (params: any) => {
        return (
          <div
            onClick={() => {
              handleMoveToEditPage(params.data);
            }}
            style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
          >
            <EditOutlined style={{ marginRight: 6 }} />

            <Typography
              style={{ color: colorPicker("neutral.800") }}
              variant="xs"
            >
              {params.data?.name}
            </Typography>
          </div>
        );
      },
      valueGetter: (params: any) => params.data?.name,
      filter: "agTextColumnFilter",
    },
    // {
    //   field: "email_address",
    //   headerName: "Contact Person",
    //   filter: "agTextColumnFilter",
    //   editable: true,
    // },

    {
      field: "created_at",
      headerName: "Created At",
      filter: "agTextColumnFilter",
      cellRenderer: (params: any) => {
        return moment(params.data?.created_at).format("DD MMM YYYY");
      },
    },

    {
      field: "entity_type",
      headerName: "Entity Type",
      filter: "agTextColumnFilter",
      cellRenderer: (params: any) => {
        return <Tag>{params.data.entity_type}</Tag>;
      },
    },

    ...(userDetails.email.includes("kgrp.in") ||
    userDetails.email.includes("finkraft.ai")
      ? [
          {
            field: "entity_type",
            headerName: "Entity Type",
            filter: "agTextColumnFilter",
            cellRenderer: (params: any) => {
              return params.data.entity_type === "INTERMEDIARY" ? null : (
                <div>
                  <Popconfirm
                    title="Are you sure want to remove this workspace?"
                    onConfirm={() =>
                      handleRemoveWorksapceFromGroup(params?.data?.id)
                    }
                    onCancel={() => null}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button
                      size="small"
                      icon={<DeleteOutlined />}
                      danger
                      style={{ marginLeft: 12 }}
                    >
                      Remove Workspace
                    </Button>
                  </Popconfirm>
                </div>
              );
            },
          },
        ]
      : []),

    // {
    //   field: "is_active",
    //   headerName: "Verified",
    //   enableRowGroup: true,
    //   minWidth: 200,

    //   valueGetter: (params: any) => params.data?.approval?.length,
    //   cellRenderer: (params: any) => {
    //     return params.data?.approval && params.data?.approval?.length > 0 ? (
    //       <Tag color="green">Verified</Tag>
    //     ) : (
    //       <Tag color="orange">Verification Pending</Tag>
    //     );
    //   },
    // },
    // {
    //   field: "users",
    //   headerName: "Users",
    //   enableRowGroup: true,
    //   minWidth: 200,
    //   cellRenderer: (params: any) => {
    //     return params?.data?.users.length === 0 ? (
    //       <Tag color="red">Add User</Tag>
    //     ) : (
    //       <div style={{ display: "flex", alignItems: "center" }}>
    //         {params.data?.users.map((user: any, key: any) => {
    //           return <Tag>{user.email}</Tag>;
    //         })}
    //       </div>
    //     );
    //   },
    // },
  ];
  useEffect(() => {
    setColumnDefs(initialColDefs);
  }, []);
  useEffect(() => {
    fetchWorkspaceList();
  }, [userDetails.currentWorkspace]);
  const fetchWorkspaceList = async () => {
    setLoading(true);
    const response = await apiGet(API_ENDPOINT_SETTING_WORKSPACE_LIST);
    if (response.status) {
      setTableData(response.data);
      setWorkspaceList(response.data);//new--
    } else {
      messageApi.error({
        type: "error",
        content: response.message,
      });
    }
    setLoading(false);
  };

  const handleExportTableData = () => {
    if (gridRef.current && gridRef.current.exportDataToExcel) {
      // Call the child component's function
      gridRef.current.exportDataToExcel();
    }
  };

  const handleSuccess = () => {
    setShowModal(false);
    setSelectedWorkspace(null);
    fetchWorkspaceList();
  };

  const handleSearchWorkspace = (query: string) => {
    if (gridRef.current && gridRef.current.exportDataToExcel) {
      // Call the child component's function
      gridRef.current.onTableSearch({ target: { value: query } });
    }
  };

  function isValidEmail(email: string) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  const handleSaveEmailAddress = async (items: any) => {
    if (isValidEmail(items.email_address)) {
      const response = await apiPost(API_ENDPOINT_UPDATE_WORKSPACE_META_EMAIL, {
        email_address: items.email_address,
        workspaceId: items.id,
      });
      message.success("Email contact is updated");
    } else {
      message.error("Email is invalid");
    }
  };

  return (
    <div className="ScreenContainer">
      <PageHeader
        title="Workspace"
        rightActions={
          <div style={{ display: "flex", alignItems: "center" }}>
            {userDetails?.email.includes("kgrp.in") ||
            userDetails?.email.includes("finkraft.ai") ? (
              <Button
                style={{ marginRight: 12 }}
                type="primary"
                size="small"
                onClick={() => navigate("/settings/workspace-page")} // Use navigate function here
              >
                NewWorkspacePage
              </Button>
            ) : null}
            <div style={{ marginRight: 12 }}>
              <SearchInput
                placeholder="Search worksapces"
                onSearch={handleSearchWorkspace}
              />
            </div>
            <Button
              type="primary"
              size="small"
              // icon={<PlusOutlined />}
              onClick={() => {
                gridRef.current && gridRef.current.exportDataToExcel();
              }}
              // onClick={() => {
              //   setShowModalFor("CREATE");
              //   setShowModal(true);
              // }}
            >
              Export Workspaces
            </Button>
            {userDetails?.account_type === "PARTNER" ? (
              <Button
                type="primary"
                size="small"
                icon={<PlusOutlined />}
                onClick={() => {
                  setShowModalFor("CREATE");
                  setShowModal(true);
                }}
                style={{ marginLeft: 12 }}
              >
                Add Workspace
              </Button>
            ) : null}
          </div>
        }
      />
      <div className="TableContainer">
        {isLoading ? (
          <Loader />
        ) : tableData.length === 0 ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              height: "100%",
              justifyContent: "center",
            }}
          >
            <Empty />
          </div>
        ) : (
          <AgTableClient
            // @ts-ignore
            rowData={tableData}
            columnDefs={columnDefs}
            groupPanel
            // onRowSaved={handleRowEdit}
            enableDirectEdit
            ref={gridRef}
            footer={false}
            autoResize
            showStatusBar
            onRowSaved={handleSaveEmailAddress}
          />
        )}
      </div>

      <Modal
        title={showModalFor === "UPDATE" ? "Edit Workspace" : "Add Workspace"}
        open={showModal}
        footer={false}
        onCancel={() => setShowModal(false)}
        width={800}
      >
        {showModalFor === "UPDATE" ? (
          <UpdateWorkspace
            workspace={selectedWorkspace}
            onSuccess={handleSuccess}
          />
        ) : (
          <CreateWorkspace onSuccess={handleSuccess}  existingWorkspaces={workspaceList}/>
        )}
      </Modal>
      {contextHolder}
    </div>
  );
}
